import { render, staticRenderFns } from "./ProductRange.vue?vue&type=template&id=6fd89e03&"
import script from "./ProductRange.vue?vue&type=script&lang=js&"
export * from "./ProductRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports